<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
  <span class="w-full input-field p-input-icon-right">
    <input pInputText  placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()" class="w-full"/>
    <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer" (click)="filters.name.value = null; search()"></i>
  </span>
</div>
-->

<p-table #grid [value]="reports" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading" [paginator]="true"
          [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
          [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th width="250" pSortableColumn="dataset.name">Conjunto de datos<p-sortIcon field="dataset.name"></p-sortIcon></th>
      <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
      <th pSortableColumn="name">Creado por <p-sortIcon field="name"></p-sortIcon></th>
      <th width="100"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-report let-columns="columns">
    <tr (dblclick)="visualization(report)">      
      <td>
        {{report.dataset?.name}}
      </td>
      <td>
        <div class="flex align-items-center gap-1">
          <i class="pi pi-book"></i>
          <div>
            {{report.name}}
            <div *ngIf="report.isSystem"><small><i class="pi pi-lock" style="font-size: 8px;"></i> Informe de sistema</small></div>
          </div>
        </div>
      </td>
      <td>
        <i class="pi pi-user"></i> {{report.createdByUser?.name}}
      </td>
      <td>
        <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete && !report.isSystem" (click)="delete(report)" [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>

          <p-button *ngIf="allowWrite && loginService.hasPermission('REPORTS.PERMISSIONS')" (click)="permissions(report)" [rounded]="true" [text]="false"><i class="pi pi-users"></i></p-button>
          <p-button *ngIf="allowWrite" (click)="visualization(report)" [rounded]="true" [text]="false"><i class="pi pi-eye"></i></p-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
        <td [attr.colspan]="3">
            No se ha encontrado informes
        </td>
    </tr>
</ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>